module.exports = __webpack_public_path__ + "03_short_black.52041ac1.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/03_short_black.png
// module id = kLUR
// module chunks = 0